/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChartDTO } from '../models/ChartDTO';
import type { UsageStatDTO } from '../models/UsageStatDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StatisticsService {

    /**
     * @param startDate 
     * @param endDate 
     * @param userId 
     * @param clientId 
     * @param dateInterval 
     * @param renderType 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsInsitu(
startDate?: string,
endDate?: string,
userId?: number,
clientId?: number,
dateInterval?: string,
renderType?: string,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/insitu',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'userId': userId,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'renderType': renderType,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param userId 
     * @param clientId 
     * @param dateInterval 
     * @param renderType 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsCutout(
startDate?: string,
endDate?: string,
userId?: number,
clientId?: number,
dateInterval?: string,
renderType?: string,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/cutout',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'userId': userId,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'renderType': renderType,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param userId 
     * @param clientId 
     * @param dateInterval 
     * @param renderType 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatistics360Spin(
startDate?: string,
endDate?: string,
userId?: number,
clientId?: number,
dateInterval?: string,
renderType?: string,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/360spin',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'userId': userId,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'renderType': renderType,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param userId 
     * @param clientId 
     * @param dateInterval 
     * @param renderType 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsVideo(
startDate?: string,
endDate?: string,
userId?: number,
clientId?: number,
dateInterval?: string,
renderType?: string,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/video',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'userId': userId,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'renderType': renderType,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param userId 
     * @param clientId 
     * @param dateInterval 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsProject(
startDate?: string,
endDate?: string,
userId?: number,
clientId?: number,
dateInterval?: string,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/project',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'userId': userId,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param clientId 
     * @param dateInterval 
     * @param isEnabled 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsAsset(
startDate?: string,
endDate?: string,
clientId?: number,
dateInterval?: string,
isEnabled?: boolean,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/asset',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'isEnabled': isEnabled,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param clientId 
     * @param dateInterval 
     * @param isEnabled 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsScene(
startDate?: string,
endDate?: string,
clientId?: number,
dateInterval?: string,
isEnabled?: boolean,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/scene',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'isEnabled': isEnabled,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param clientId 
     * @param dateInterval 
     * @param isEnabled 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsStyling(
startDate?: string,
endDate?: string,
clientId?: number,
dateInterval?: string,
isEnabled?: boolean,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/styling',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'clientId': clientId,
                'dateInterval': dateInterval,
                'isEnabled': isEnabled,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param startDate 
     * @param endDate 
     * @param dateInterval 
     * @param isEnabled 
     * @param templateType 
     * @param displayMode 
     * @returns ChartDTO Success
     * @throws ApiError
     */
    public static getStatisticsDamupload(
startDate?: string,
endDate?: string,
dateInterval?: string,
isEnabled?: boolean,
templateType?: string,
displayMode?: string,
): CancelablePromise<ChartDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/damupload',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'dateInterval': dateInterval,
                'isEnabled': isEnabled,
                'templateType': templateType,
                'displayMode': displayMode,
            },
        });
    }

    /**
     * @param clientId 
     * @param renderType 
     * @returns UsageStatDTO Success
     * @throws ApiError
     */
    public static getStatisticsUsage(
clientId?: number,
renderType?: string,
): CancelablePromise<Array<UsageStatDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/Statistics/usage',
            query: {
                'clientId': clientId,
                'renderType': renderType,
            },
        });
    }

}
